module.exports = __webpack_public_path__ + "static/media/nuevoInforme-2.1736299f.jpg";